export const COLORS = [
  '#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6',
  '#EC4899', '#14B8A6', '#F97316', '#6366F1', '#84CC16',
  '#06B6D4', '#D946EF', '#22C55E', '#EAB308', '#0EA5E9',
];

export function generateId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function calculateSegmentAngle(count) {
  return count > 0 ? 360 / count : 0;
}

/**
 * IMPORTANT: Wheel.js draws segment 0 starting at the TOP (-90°, i.e. 270°),
 * not at 0° (the pointer's position on the right). Every formula below must
 * account for that -90° draw offset, or the visual wedge under the pointer
 * will not match the index these functions return.
 */
const DRAW_OFFSET = 270; // equivalent to -90deg, normalized to 0-360

export function calculateWinnerIndex(rotation, entryCount) {
  if (entryCount === 0) return -1;
  const normalized = ((rotation % 360) + 360) % 360;
  const segment = 360 / entryCount;

  // Unrotated-frame angle that currently sits under the fixed pointer (0deg/right)
  const theta = (360 - normalized) % 360;

  // Shift into the wheel's own drawing frame (which starts at DRAW_OFFSET)
  const adjusted = ((theta - DRAW_OFFSET) % 360 + 360) % 360;

  return Math.floor(adjusted / segment) % entryCount;
}

export function calculateTargetRotation(currentRotation, targetIndex, entryCount, extraSpins = 5) {
  if (entryCount === 0) return currentRotation;
  const segment = 360 / entryCount;

  // Center of the target segment, in the wheel's own drawing frame
  const segmentCenter = DRAW_OFFSET + targetIndex * segment + segment / 2;

  // Rotation (normalized) needed to bring that center to the pointer (0deg/right)
  const targetAngle = ((360 - segmentCenter) % 360 + 360) % 360;

  const fullSpins = extraSpins * 360;
  const currentNormalized = ((currentRotation % 360) + 360) % 360;
  let delta = (targetAngle - currentNormalized + 360) % 360;
  if (delta < 20) delta += 360;
  return currentRotation + fullSpins + delta;
}

export function shuffleEntries(entries) {
  const arr = [...entries];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function sortEntries(entries, direction = 'asc') {
  return [...entries].sort((a, b) => {
    const cmp = a.text.localeCompare(b.text, undefined, { sensitivity: 'base' });
    return direction === 'asc' ? cmp : -cmp;
  });
}

export function getRandomEntry(entries, lastWinnerId = null, preventRepeat = false) {
  if (!entries.length) return null;
  if (entries.length === 1) return entries[0];

  let pool = entries;
  if (preventRepeat && lastWinnerId) {
    pool = entries.filter((e) => e.id !== lastWinnerId);
    if (pool.length === 0) pool = entries;
  }
  return pool[Math.floor(Math.random() * pool.length)];
}